'use client';

import React from 'react';
import { AuthProvider } from './auth-provider';
import { ThemeProvider } from './theme-provider';
import { NotificationProvider } from './notification-provider';
import { QueryProvider } from './query-provider';
import { LenisProvider } from './lenis-provider';
import { OfflineProvider } from './offline-provider';
import { ErrorBoundary } from '@/errors/error-boundary';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ErrorBoundary>
      <LenisProvider>
        <ThemeProvider>
          <AuthProvider>
            <QueryProvider>
              <NotificationProvider>
                <OfflineProvider>
                  {children}
                </OfflineProvider>
              </NotificationProvider>
            </QueryProvider>
          </AuthProvider>
        </ThemeProvider>
      </LenisProvider>
    </ErrorBoundary>
  );
}
